import script from "./TalentNode.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentNode.vue?vue&type=script&setup=true&lang=js"

import "./TalentNode.vue?vue&type=style&index=0&id=3750acb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3750acb2"]])

export default __exports__